export default function getAccountName(item, returnNa) {
  if (typeof item !== 'object' || (!item?.accountNumber && !item?.accountName)) {
    return returnNa ? 'N/A' : '';
  }

  let displayName = item.accountNumber;

  if (!displayName) {
    displayName = item.accountName;
  } else if (item?.accountName !== displayName) {
    displayName = `${ displayName } - ${ item.accountName }`;
  }

  return displayName;
}
